/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { FunctionComponent, useMemo } from 'react';
import FederatedMFE from 'common/components/FederatedMFE';
import { useSelector } from 'react-redux';
import {
  isProjectArchived,
  isProjectInactive,
} from 'common/helpers/projectStatusesUtils';
import { getProject } from 'features/project/projectSlice';
import {
  getFakeClientUser,
  getIsThirdPartyMember,
  getUserRole,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';

import { injectReducerAsync } from 'app/reduxStore';

import styles from './FilesPage.module.scss';

const FilesPage: FunctionComponent = () => {
  const project = useSelector(getProject);
  const isFakeClientUser = useSelector(getFakeClientUser);
  const userRole = useSelector(getUserRole);
  const isThirdPartyMember = useSelector(getIsThirdPartyMember);

  const extraProps = useMemo(
    () => ({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      projectInfo: {
        ...project,
        isProjectArchived: isProjectArchived(project?.status),
        isProjectInactive: isProjectInactive(project?.status),
      },
      isFakeClientUser,
      userRole,
      isThirdPartyMember,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isFakeClientUser, userRole]
  );

  return (
    <div className={styles.wrapper}>
      <div>
        <FederatedMFE
          urlKey="REACT_APP_FILES_FOLDERS_MFE_URL"
          scope="remoteFilesFolders"
          reducerModule="./filesReducers"
          componentModule="./FilesPage"
          injectionReducerCb={injectReducerAsync}
          suspenseFallbackStyle={styles['suspense-loader-wrapper']}
          props={extraProps}
        />
      </div>
    </div>
  );
};

export default FilesPage;
